import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciInputComponent } from './luci-input.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [LuciInputComponent],
  exports: [LuciInputComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class LuciInputModule { }
